
export const do_action = (action_name = null, value = {}) => {
  return {
    type: action_name,
    payload : value
  }
}

export default do_action;


// WEBPACK FOOTER //
// ./src/action/index.js